import { useQuery } from "@tanstack/react-query";

import { orvalClient } from "@/api";

// Hand-written client for the /clinic/video-visit/consent endpoints. These
// types mirror superclinical-be's VideoVisitConsentResponse; once the backend
// is running, `bun run gen:api` will produce equivalents under api/generated and
// these can be swapped for the generated hooks.
// `recording_consent` is a TRI-STATE: true (consented), false (explicitly
// declined), or null (no decision yet). The transcription/AI gate treats
// anything but true as not allowed; the null-vs-false distinction lets the
// in-call consent prompt avoid re-asking a patient who already declined.
export interface VideoVisitConsentResponse {
  encounter_id: string;
  recording_consent: boolean | null;
}

export const getVideoVisitConsentQueryKey = (encounterId?: string | null) => [
  "video-visit",
  "consent",
  encounterId,
];

export const useGetVideoVisitRecordingConsent = (encounterId?: string | null) =>
  useQuery({
    queryKey: getVideoVisitConsentQueryKey(encounterId),
    queryFn: () =>
      orvalClient<VideoVisitConsentResponse>({
        url: "/clinic/video-visit/consent",
        method: "GET",
        params: { encounter_id: encounterId },
      }),
    enabled: Boolean(encounterId),
  });
